import { useState, useEffect } from 'react';
import { useLang } from '../i18n/LanguageContext';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';
const headers = () => ({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('token') });

const PROVIDERS = [
  {
    key: 'click',
    name: 'Click',
    icon: '💳',
    color: '#00c2ff',
    fields: [
      { env: 'CLICK_MERCHANT_ID', label: 'Merchant ID', type: 'text' },
      { env: 'CLICK_SERVICE_ID',  label: 'Service ID',  type: 'text' },
      { env: 'CLICK_SECRET_KEY',  label: 'Secret Key',  type: 'password' },
      { env: 'CLICK_RETURN_URL',  label: 'Return URL',  type: 'text' },
    ],
    docs: 'my.click.uz → Merchant → Xizmatlar',
    webhook: '/api/payments/click/prepare  (POST)\n/api/payments/click/complete (POST)',
  },
  {
    key: 'payme',
    name: 'Payme',
    icon: '🔵',
    color: '#1aa3e8',
    fields: [
      { env: 'PAYME_MERCHANT_ID', label: 'Merchant ID',  type: 'text' },
      { env: 'PAYME_SECRET_KEY',  label: 'Secret Key',   type: 'password' },
    ],
    docs: 'merchant.paycom.uz → Ilova → Sozlamalar',
    webhook: '/api/payments/payme  (POST, JSONRPC)',
  },
  {
    key: 'uzum',
    name: 'Uzum',
    icon: '🟣',
    color: '#8b5cf6',
    fields: [
      { env: 'UZUM_SHOP_ID',  label: 'Shop ID',    type: 'text' },
      { env: 'UZUM_SECRET',   label: 'Secret Key', type: 'password' },
    ],
    docs: 'uzum.uz → Merchant → API kalitlar',
    webhook: '/api/payments/uzum/prepare  (POST)\n/api/payments/uzum/complete (POST)',
  },
  {
    key: 'apelsin',
    name: 'Apelsin',
    icon: '🟠',
    color: '#f97316',
    fields: [
      { env: 'APELSIN_SECRET', label: 'Secret Key', type: 'password' },
    ],
    docs: 'apelsin.uz → Merchant',
    webhook: '/api/payments/apelsin  (POST, JSONRPC)',
  },
  {
    key: 'anor',
    name: 'Anor',
    icon: '🔴',
    color: '#ef4444',
    fields: [
      { env: 'ANOR_SERVICE_ID', label: 'Service ID',  type: 'text' },
      { env: 'ANOR_SECRET',     label: 'Secret Key',  type: 'password' },
    ],
    docs: 'anor.uz → Merchant',
    webhook: '/api/payments/anor/prepare  (POST)\n/api/payments/anor/complete (POST)',
  },
  {
    key: 'humo',
    name: 'Humo / Uzcard',
    icon: '🟤',
    color: '#78716c',
    fields: [],
    docs: 'Humo/Uzcard — coming soon',
    webhook: '',
    comingSoon: true,
  },
];

function ProviderCard({ provider, testResult, onTest, t }) {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState('');

  const copy = (text, key) => {
    navigator.clipboard.writeText(text);
    setCopied(key);
    setTimeout(() => setCopied(''), 1500);
  };

  const isConfigured = provider.fields.length > 0;

  return (
    <div style={{
      background: 'var(--bg2)', border: `1px solid ${provider.comingSoon ? 'var(--border)' : provider.color + '33'}`,
      borderRadius: 12, overflow: 'hidden', opacity: provider.comingSoon ? 0.6 : 1
    }}>
      <div
        style={{ padding: '16px 20px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 12 }}
        onClick={() => !provider.comingSoon && setOpen(o => !o)}
      >
        <span style={{ fontSize: 24 }}>{provider.icon}</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontWeight: 700, fontSize: 15, color: provider.comingSoon ? 'var(--text3)' : 'var(--text1)' }}>
            {provider.name}
            {provider.comingSoon && (
              <span style={{ marginLeft: 8, fontSize: 10, background: 'rgba(120,113,108,0.2)', color: 'var(--text3)', padding: '2px 6px', borderRadius: 4 }}>
                {t('launcherComingSoon')}
              </span>
            )}
          </div>
          <div style={{ fontSize: 12, color: 'var(--text3)', marginTop: 2 }}>{provider.docs}</div>
        </div>
        {!provider.comingSoon && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {testResult && (
              <span style={{
                fontSize: 11, padding: '3px 8px', borderRadius: 6,
                background: testResult.ok ? 'rgba(34,197,94,0.1)' : 'rgba(239,68,68,0.1)',
                color: testResult.ok ? '#22c55e' : '#ef4444',
                border: `1px solid ${testResult.ok ? '#22c55e' : '#ef4444'}`,
              }}>
                {testResult.ok ? t('payConnOk') : t('payConnFail')}
              </span>
            )}
            <button
              onClick={e => { e.stopPropagation(); onTest(provider.key); }}
              style={{
                padding: '4px 12px', borderRadius: 6, fontSize: 11, cursor: 'pointer',
                background: `${provider.color}22`, border: `1px solid ${provider.color}66`,
                color: provider.color,
              }}
            >
              Test
            </button>
            <span style={{ color: 'var(--text3)', fontSize: 14 }}>{open ? '▲' : '▼'}</span>
          </div>
        )}
      </div>

      {open && !provider.comingSoon && (
        <div style={{ borderTop: '1px solid var(--border)', padding: 20 }}>
          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 10, fontWeight: 600, letterSpacing: 1 }}>
              {t('payEnvSettings')}
            </div>
            {isConfigured ? (
              <div style={{ background: 'var(--bg3)', borderRadius: 8, padding: 12, fontFamily: 'monospace' }}>
                {provider.fields.map(f => (
                  <div key={f.env} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                    <span style={{ color: provider.color, minWidth: 200, fontSize: 12 }}>{f.env}</span>
                    <span style={{ color: 'var(--text3)', fontSize: 12 }}>=</span>
                    <span style={{ color: 'var(--text2)', fontSize: 12, flex: 1 }}>
                      {f.type === 'password' ? '••••••••••••' : '<your_value>'}
                    </span>
                    <button
                      onClick={() => copy(f.env, f.env)}
                      style={{
                        background: 'transparent', border: '1px solid var(--border)',
                        color: 'var(--text3)', cursor: 'pointer', borderRadius: 4,
                        padding: '2px 6px', fontSize: 10
                      }}
                    >
                      {copied === f.env ? '✓' : t('payCopyBtn')}
                    </button>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ color: 'var(--text3)', fontSize: 13 }}>{t('payNoEnvRequired')}</div>
            )}
          </div>

          <div style={{ marginBottom: 16 }}>
            <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 6, fontWeight: 600, letterSpacing: 1 }}>
              {t('payWebhookLabel')}
            </div>
            <div style={{ background: 'var(--bg3)', borderRadius: 8, padding: 12 }}>
              <pre style={{ margin: 0, fontSize: 12, color: '#22c55e', fontFamily: 'monospace', whiteSpace: 'pre-wrap' }}>
                {provider.webhook}
              </pre>
            </div>
          </div>

          <div style={{
            background: `${provider.color}11`, border: `1px solid ${provider.color}33`,
            borderRadius: 8, padding: 12, fontSize: 12, color: 'var(--text2)'
          }}>
            <span style={{ color: provider.color, fontWeight: 600 }}>{t('payInstructions')} </span>
            {t('payDocsInstr')}
          </div>
        </div>
      )}
    </div>
  );
}

function GlobalLimits({ limits, onChange, onSave, saving, t }) {
  return (
    <div style={{ background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12, padding: 20, marginBottom: 24 }}>
      <div style={{ fontWeight: 700, fontSize: 14, color: 'var(--text1)', marginBottom: 16 }}>
        {t('payLimitsTitle')}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text3)', display: 'block', marginBottom: 6 }}>
            {t('payMinLabel')} ({t('currency')})
          </label>
          <input
            type="number"
            value={limits.min}
            onChange={e => onChange({ ...limits, min: e.target.value })}
            style={{
              width: '100%', background: 'var(--bg3)', border: '1px solid var(--border)',
              borderRadius: 8, padding: '8px 12px', color: 'var(--text1)', fontSize: 14, boxSizing: 'border-box'
            }}
          />
        </div>
        <div>
          <label style={{ fontSize: 12, color: 'var(--text3)', display: 'block', marginBottom: 6 }}>
            {t('payMaxLabel')} ({t('currency')})
          </label>
          <input
            type="number"
            value={limits.max}
            onChange={e => onChange({ ...limits, max: e.target.value })}
            style={{
              width: '100%', background: 'var(--bg3)', border: '1px solid var(--border)',
              borderRadius: 8, padding: '8px 12px', color: 'var(--text1)', fontSize: 14, boxSizing: 'border-box'
            }}
          />
        </div>
      </div>
      <div style={{ marginTop: 12, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: 12, color: 'var(--text3)' }}>
          ENV: <code style={{ color: 'var(--cyan)' }}>PAYMENT_MIN</code> / <code style={{ color: 'var(--cyan)' }}>PAYMENT_MAX</code>
        </span>
        <button
          onClick={onSave}
          disabled={saving}
          style={{
            padding: '8px 20px', borderRadius: 8, cursor: 'pointer', fontSize: 13,
            background: 'rgba(0,212,255,0.15)', border: '1px solid var(--cyan)', color: 'var(--cyan)',
            opacity: saving ? 0.6 : 1
          }}
        >
          {saving ? t('savingLabel') : t('save')}
        </button>
      </div>
    </div>
  );
}

export default function PaymentSettings() {
  const { t } = useLang();
  const [testResults, setTestResults] = useState({});
  const [testing, setTesting]         = useState('');
  const [limits, setLimits]           = useState({ min: 5000, max: 10000000 });
  const [saving, setSaving]           = useState(false);
  const [stats, setStats]             = useState(null);

  useEffect(() => {
    fetch(`${API}/payments/stats`, { headers: headers() })
      .then(r => r.ok ? r.json() : null)
      .then(d => d && setStats(d))
      .catch(() => {});
  }, []);

  const handleTest = async (providerKey) => {
    setTesting(providerKey);
    try {
      const r = await fetch(`${API}/payments/test/${providerKey}`, {
        method: 'POST', headers: headers()
      });
      const data = await r.json();
      setTestResults(prev => ({ ...prev, [providerKey]: { ok: r.ok && !data.error, msg: data.message || data.error } }));
    } catch {
      setTestResults(prev => ({ ...prev, [providerKey]: { ok: false, msg: t('payConnFailed') } }));
    }
    setTesting('');
  };

  const handleSaveLimits = async () => {
    setSaving(true);
    await new Promise(r => setTimeout(r, 500));
    setSaving(false);
    alert(t('payLimitsAlert') + 'PAYMENT_MIN=' + limits.min + '\nPAYMENT_MAX=' + limits.max);
  };

  return (
    <div style={{ maxWidth: 900 }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ margin: 0, fontSize: 24, fontFamily: 'Orbitron, sans-serif' }}>
          {t('payTitle')}
        </h1>
        <p style={{ margin: '8px 0 0', color: 'var(--text3)', fontSize: 14 }}>
          {t('paySubtitle')}
        </p>
      </div>

      <div style={{
        background: 'rgba(251,191,36,0.08)', border: '1px solid rgba(251,191,36,0.3)',
        borderRadius: 10, padding: '12px 16px', marginBottom: 24,
        display: 'flex', alignItems: 'center', gap: 10
      }}>
        <span style={{ fontSize: 18 }}>⚠️</span>
        <div style={{ fontSize: 13, color: '#fbbf24' }}>
          {t('payWarning')}
        </div>
      </div>

      {stats && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 24 }}>
          {[
            { label: t('payStatTotal'),   value: stats.total_count || 0 },
            { label: t('payStatSuccess'), value: stats.success_count || 0 },
            { label: t('payStatPending'), value: stats.pending_count || 0 },
            { label: t('payStatAmount'),  value: `${Number(stats.total_amount || 0).toLocaleString()} ${t('currency')}` },
          ].map(s => (
            <div key={s.label} style={{
              background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 10, padding: '14px 16px'
            }}>
              <div style={{ fontSize: 12, color: 'var(--text3)' }}>{s.label}</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text1)', marginTop: 4 }}>{s.value}</div>
            </div>
          ))}
        </div>
      )}

      <GlobalLimits limits={limits} onChange={setLimits} onSave={handleSaveLimits} saving={saving} t={t} />

      <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12, fontWeight: 600, letterSpacing: 1 }}>
        {t('payProviderLabel')} — {t('payProviderHint')}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        {PROVIDERS.map(p => (
          <ProviderCard
            key={p.key}
            provider={p}
            testResult={testResults[p.key]}
            onTest={testing ? () => {} : handleTest}
            t={t}
          />
        ))}
      </div>

      <div style={{
        background: 'var(--bg2)', border: '1px solid var(--border)', borderRadius: 12,
        padding: 20, marginTop: 24
      }}>
        <div style={{ fontSize: 12, color: 'var(--text3)', marginBottom: 12, fontWeight: 600, letterSpacing: 1 }}>
          {t('payEnvExample')}
        </div>
        <pre style={{
          margin: 0, fontSize: 12, color: 'var(--text2)', fontFamily: 'monospace',
          background: 'var(--bg3)', borderRadius: 8, padding: 14, overflowX: 'auto'
        }}>{`# Click
CLICK_MERCHANT_ID=your_merchant_id
CLICK_SERVICE_ID=your_service_id
CLICK_SECRET_KEY=your_secret_key
CLICK_RETURN_URL=cybernet://payment/success

# Payme
PAYME_MERCHANT_ID=your_merchant_id
PAYME_SECRET_KEY=your_secret_key

# Uzum
UZUM_SHOP_ID=your_shop_id
UZUM_SECRET=your_secret

# Apelsin
APELSIN_SECRET=your_secret

# Anor
ANOR_SERVICE_ID=your_service_id
ANOR_SECRET=your_secret

# Limits
PAYMENT_MIN=5000
PAYMENT_MAX=10000000`}</pre>
      </div>
    </div>
  );
}
